import { Component, OnInit, Input } from '@angular/core';
import { MARVEL_CITATIONS } from '../../../../marvel-champions/views/board-game/marvel-citations.model';

@Component({
  selector: 'app-card-outline',
  templateUrl: './card-outline.component.html',
  styleUrls: ['./card-outline.component.scss']
})
export class CardOutlineComponent implements OnInit {

  @Input()
  cardOutline;

  constructor() { }

  ngOnInit() {
  }

}